import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';
import { HomePurchaseCRUD } from './Steps/HomePurchaseCRUD/HomePurchaseCRUD';
import PersonalInfoWorkflow from '../PersonalInfoWorkflow/PersonalInfoWorkflowContainer';
import TaxesWorkflow from '../TaxesWorkflow/TaxesWorkflowContainer';
import IncomeWorkflow from '../IncomeWorkflow/IncomeWorkflowContainer';
import ExpensesWorkflow from '../ExpensesWorkflow/ExpensesWorkflowContainer';
import Mortgage from '../MortgageWorkflow/MortgageWorkflowContainer';
import PropertyName from './Steps/PropertyName/PropertyNameContainer';
import YearHomePurchase from './Steps/YearHomePurchase/YearHomePurchaseContainer';
import HomeEstimatedValue from './Steps/HomeEstimatedValue/HomeEstimatedValueContainer';
import AnnualPropertyTax from './Steps/AnnualPropertyTax/AnnualPropertyTaxContainer';
import AccountsWorkflow from '../AccountsWorkflow/AccountsWorkflowContainer';
import ExpectedAnnualHomeownerInsurance from './Steps/ExpectedAnnualHomeownerInsurance/ExpectedAnnualHomeownerInsuranceContainer';
import HasHomeownerAssociationFee from './Steps/HasHomeownerAssociationFee/HasHomeownerAssociationFeeContainer';
import HomeownersAssociationFee from './Steps/HomeownersAssociationFee/HomeownersAssociationFeeContainer';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

const HomePurchaseWorkflowView = ({
  workflowId,
  clientId,
  outputFunction,
  goalId,
  isMobile,
  goToSummaryWhenReady,
  shouldSkipSummary,
  ...rest
}) => {
  useDocumentTitle('Save for Home Purchase');

  return (
    <AdvTopLevelWorkflow
      {...rest}
      clientId={clientId}
      workflowId={workflowId}
      hasAutoOutput={shouldSkipSummary}
      analyticsWorkflowStarted="home_purchase_workflow_started"
      outputFunction={outputFunction(clientId, goalId)}
      steps={[
        HomePurchaseCRUD,
        PersonalInfoWorkflow,
        TaxesWorkflow,
        IncomeWorkflow,
        ExpensesWorkflow,
        PropertyName,
        YearHomePurchase,
        HomeEstimatedValue,
        Mortgage,
        AccountsWorkflow,
        AnnualPropertyTax,
        ExpectedAnnualHomeownerInsurance,
        HasHomeownerAssociationFee,
        HomeownersAssociationFee,
      ]}
    />
  );
};

HomePurchaseWorkflowView.defaultProps = {
  goalId: null,
};

HomePurchaseWorkflowView.propTypes = {
  outputFunction: PropTypes.func.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  goalId: PropTypes.string,
};

export default HomePurchaseWorkflowView;
